import React, { ReactElement } from 'react';
import {setAppBarTitle, setBackNavEnabled} from '../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import { useEffect } from 'react';
import { EliteEnrollment } from './EnrollElite';




const Elite = (): ReactElement => {
  useEffect(() => {
    dispatch(setAppBarTitle('Benefit from ELITE'));
    dispatch(setBackNavEnabled(true));
    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);
  const dispatch = useAppDispatch()
  return (
    <div>
        <EliteEnrollment/>
    </div>
  );
};

export default Elite;
